const blogPosts = [
  {
    id: 'blog_1',
    title: 'A Gnomish Discovery',
    content: `It turns out that Paracelsus, the alchemist, was the first to describe gnomes.
    Paracelsus was passionate about the harmony of humans and nature, and in his examinations of humans and the elements,
    he described four types of elemental beings. Salamanders, Undines, and Slyphs were fire, water, and air creatures, but the earth elemental was the Gnome, according to him.
    Paracelsian gnomes are two spans (the distance from your thumb to your pinky) high and able to move as freely though earth as we are through air.
    They're not overly fond of humans and do not interact with us much.
    Incidentally, Paracelsus is believed to have named the gnomes after the Greek word for 'earth-dweller'.
    So, there you have it. Gnomes are tiny earth elementals that hate us.`,
    date: '2021-01-21',
  },
];

export default blogPosts;
